import React, { Component } from 'react';

class Spinner extends Component {

    constructor(props){
        super(props);
        let val;
        if(this.props.value > 0){
            val = this.props.value
        }else{
            val = 1;
        }
        this.state = {
            value: val
        }

        this.handleIncrease = this.handleIncrease.bind(this);
        this.handleDecrease = this.handleDecrease.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleIncrease(event){
        let itemToUpdate = 0;
        if(typeof this.props.item !== 'undefined'){
            itemToUpdate = event.target.attributes.getNamedItem('item').value;
        }
        let val = this.state.value*1+1;
        this.setState({
            value: val
        });
        this.handleChange(val, itemToUpdate);
    }

    handleDecrease(event){
        let itemToUpdate = 0;
        if(typeof this.props.item !== 'undefined'){
            itemToUpdate = event.target.attributes.getNamedItem('item').value;
        }
        let val;
        if(this.state.value > 1){
            val = this.state.value-1;
        }else{
            val = 1
        }
        this.setState({
            value: val
        });
        this.handleChange(val, itemToUpdate);
    }

    handleChange(value, item){
        if(typeof this.props.onChange !== 'undefined' && this.props.onChange !== ''){
            this.props.onChange(value, item);
        }        
    }

    render(){
        return(
            <span className="vb-number-box">
                <span onClick={this.handleDecrease} item={this.props.item}>
                    -
                </span>
                <input type="text" value={this.state.value} readOnly/>
                <span onClick={this.handleIncrease} item={this.props.item}>
                    +
                </span>								
            </span>
        )
    }
}

export default Spinner;